import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../generic-components/Icon';
import {
  chatBotIcon, chatIcon, helpCenterIcon, xStrokeIcon,
} from '../../assets/svg';
import Button from '../../generic-components/Button';
import { HELP_CENTER_LINK } from '../../constants/general';
import { STYLES, TEXTS } from './constants';
import { trackMixPanel } from '../../services/mixpanel.service';
import { useAdaService } from '../../hooks/services/useAdaService';

const ChatBot = ({ chatBotStyle } : { chatBotStyle?: string }) => {
  const { t } = useTranslation();
  const [isHelpMenuOpen, setIsHelpMenuOpen] = useState<boolean>(false);
  const [animation, setAnimation] = useState(STYLES.APPEARANCE_ANIMATION);
  const { toggleAdaChat } = useAdaService();

  return (
    <div
      id='helpMenuBtn'
      onKeyDown={() => {}}
      tabIndex={0}
      role='button'
      onClick={() => {
        if (isHelpMenuOpen) {
          setAnimation(STYLES.DISAPPEARANCE_ANIMATION);
          setTimeout(() => { setIsHelpMenuOpen(!isHelpMenuOpen); }, 600);
        } else {
          setAnimation(STYLES.APPEARANCE_ANIMATION);
          setIsHelpMenuOpen(!isHelpMenuOpen);
        }
      }}
      className={chatBotStyle || STYLES.MAIN_BTN}
    >
      {isHelpMenuOpen && (
      <div className={STYLES.BUTTONS_CONTAINER}>
        <Button
          onClick={() => {
            toggleAdaChat();
            setIsHelpMenuOpen(false);
            trackMixPanel('Act on Menu Screen', { Action: 'Chat with us' });
          }}
          childElement={(
            <>
              <Icon iconId='-adaChat' className={STYLES.CHAT_ICON} src={chatIcon} />
              <span id='ada-chat-content'>{t(TEXTS.CHAT)}</span>
            </>
        )}
          className={`${STYLES.CHAT_BTN} ${animation}`}
          id='ChatCta'
        />
        <Button
          onClick={() => {
            window.open(HELP_CENTER_LINK, '_blank');
            trackMixPanel('Act on Menu Screen', { Action: 'Help Center' });
          }}
          childElement={(
            <>
              <Icon iconId='helpCenterIcon' className={STYLES.HELP_CENTER_ICON} src={helpCenterIcon} />
              <span>{t(TEXTS.HELP_CENTER)}</span>
            </>
        )}
          className={`${STYLES.HELP_CENTER_BTN} ${animation}`}
          id='HelpCta'
        />
      </div>
      )}
      {isHelpMenuOpen ? <Icon iconId='-adaClose' className={STYLES.X_ICON} src={xStrokeIcon} />
        : <Icon iconId='-adaOpen' className={STYLES.CHAT_QUESTION_ICON} src={chatBotIcon} />}
    </div>
  );
};

export default ChatBot;
